import { requestFactory } from '@/plugins/axios'
// {machine}
export function onSubmit(data) {
   return requestFactory({
        url: '/machine/save',
        method: 'POST',
        data: data
      })
}
